import { CART_AED_TO_INR_VALUE } from '../../../../utils/constants/GlobalStaticData';

// Cart currency types: 1 = INR, 2 = AED, 3 = AED to INR.
// When an item's currency is AED (2), the amount fields hold AED values.
// This returns the equivalent INR (AED * CART_AED_TO_INR_VALUE) to show inline
// alongside the AED amount; returns undefined for every other currency so the
// helper text is hidden.
export const inrEquivalentText = (selectedCurrency, value) => {
  if (Number(selectedCurrency) !== 2) return undefined;
  const amount = parseFloat(value);
  if (!amount || Number.isNaN(amount)) return undefined;
  const inr = Math.round(amount * CART_AED_TO_INR_VALUE);
  return `≈ ₹${inr.toLocaleString('en-IN')}`;
};

// Shared sx for the inline INR helper text under amount fields.
// The amount inputs are left-aligned with `5px 10px` padding inside the rounded
// field, so the helper text is left-aligned with a matching left offset
// (~border + input padding) to sit directly under the typed value.
export const inrHelperTextProps = {
  sx: {
    mt: 0.3,
    mb: 0,
    mx: 0,
    pl: '12px',
    fontSize: '0.65rem',
    lineHeight: 1.3,
    textAlign: 'left',
    whiteSpace: 'nowrap',
    color: 'primary.main',
  },
};
